import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class BacklogInitiativesInitiativeWeeksRoute extends Route {
  @service betaToggle;
  @service router;

  beforeModel() {
    if (!this.betaToggle.showPlanning)
      this.router.transitionTo('backlog.initiatives.initiative.description');
  }

  model() {
    return this.modelFor('backlog.initiatives.initiative');
  }
}

export default instrumentRoutePerformance(
  BacklogInitiativesInitiativeWeeksRoute,
);
